export default {
  // Worlds
  worldSeen: 'An den Seen',
  worldMuenchen: 'In München',
  worldBerge: 'In den Bergen',
  worldKultur: 'Kultur & Geschichte',
  worldGauting: 'Direkt in Gauting',

  // Hero
  exHeroLabel: 'Ausflugsziele',
  exHeroTitle: 'Heute See.\nMorgen Stadt.\nÜbermorgen Alpen.',
  exHeroText: 'Rund um den Alpenhof warten Tage, die sich ganz unterschiedlich anfühlen dürfen. Mal zieht es einen ans Wasser, mal in die Stadt, mal Richtung Berge.',

  // Section labels
  exSelectorPrompt: 'Was zieht Sie heute an?',
  exFinderTile: 'Ausflug-Finder',
  exFinderSub: 'Wonach ist mir heute?',
  exShowAll: 'Alle Ziele anzeigen',
  exGridTitleAll: 'Alle Ausflugsziele',
  exGridSubtitle: 'Wählen Sie oben eine Welt – oder stöbern Sie einfach durch alle.',
  exCardCount: 'Ausflugsziele',
  exCardZielePrefix: 'Ziele',
  exShowMore: 'Mehr anzeigen ({{count}} weitere)',
  exShowLess: 'Weniger anzeigen',
  exExpandPrompt: 'Tippen für mehr Details & Insider-Tipps',
  exMapLink: 'Auf Google Maps öffnen',
  exMoreInfo: 'Mehr Infos',

  // Distance ticker
  exDistanceTitle: 'Alles liegt nah',
  distStarnberger: 'Starnberger See',
  distMuenchen: 'München Hbf',
  distAndechs: 'Kloster Andechs',
  distAmmersee: 'Ammersee',
  distWuermtal: 'Würmtal',
  distAlpen: 'Bayerische Alpen',
  distGauting: 'Gauting Ortskern',
  time15min: '15 Min.',
  time25min: '25 Min.',
  time30min: '30 Min.',
  time60min: '60 Min.',
  timeDirect: 'Direkt',

  // Externe Programm-Links
  linkProgramNymphenburg: 'Programm Schloss Nymphenburg',
  linkProgramPinakothek: 'Programm Pinakothek',
  linkProgramBuchheim: 'Programm Buchheim Museum',
  linkProgramDeutschesMuseum: 'Programm Deutsches Museum',
  linkProgramBosco: 'Programm BOSCO',

  // CTA
  exCtaLabel: 'Ihr Aufenthalt im Alpenhof',
  exCtaTitle: 'So viele Ausflüge. So nah am Hotel.',
  exCtaText: 'Sichern Sie sich Ihre Wunschtage – wir freuen uns, Ihnen die schönsten Seiten der Region zu zeigen.',
  exCtaButton: 'Zimmer auswählen',

  // Mood Finder
  moodKicker: 'Ausflug-Finder',
  moodTitle: 'Wonach ist Ihnen heute?',
  moodSubtitle: '3 kurze Fragen – und wir empfehlen Ihnen zwei perfekte Ziele.',
  moodQ1: 'Wie ist Ihr heutiger Energielevel?',
  moodQ1Low: '😴 Eher entspannt',
  moodQ1Mid: '🚶 Mittel – ich gehe gerne',
  moodQ1High: '🏃 Hoch – ich will was erleben!',
  moodQ2: 'Was zieht Sie mehr an?',
  moodQ2Nature: '🌿 Natur & Stille',
  moodQ2Culture: '🏛️ Kultur & Geschichte',
  moodQ2Food: '🍺 Genuss & Geselligkeit',
  moodQ3: 'Wie weit darf es sein?',
  moodQ3Near: '🚶 Direkt vor Ort',
  moodQ3Medium: '🚗 Bis 30 Minuten',
  moodQ3Far: '🗺️ Auch weiter weg',
  moodResultsLead: 'Unsere zwei Empfehlungen für Sie heute:',
  moodTip1: 'Tipp 1',
  moodTip2: 'Tipp 2',
  moodMapLink: 'Auf Karte ansehen',
  moodReset: 'Nochmal versuchen',

  // Excursions (visible items, surface only)
  ex1Title: 'Starnberger See',
  ex1Tagline: 'Bayerns schönstes Wasser',
  ex1Mood: '🌊 Entspannung pur',
  ex1Duration: '15 Min.',

  ex2Title: 'Ammersee',
  ex2Tagline: 'Weite, Wasser und Wind',
  ex2Mood: '⛵ Segeln & Seele baumeln',
  ex2Duration: '25 Min.',

  ex3Title: 'Roseninsel besuchen',
  ex3Tagline: 'Die kleine Insel im See',
  ex3Mood: '🌹 Königliche Atmosphäre',
  ex3Duration: '20 Min.',

  ex4Title: 'Zur Votivkapelle in Berg spazieren',
  ex4Tagline: 'Stimmungsvoller Spaziergang am Seeufer',
  ex4Mood: '⛪ Stimmungsvoll & historisch',
  ex4Duration: '15 Min.',

  ex5Title: 'Im Lenné-Park in Feldafing flanieren',
  ex5Tagline: 'Alte Bäume und Seeblick',
  ex5Mood: '🌳 Parkspaziergang',
  ex5Duration: '20 Min.',

  ex6Title: 'Eine Überfahrt auf dem Starnberger See machen',
  ex6Tagline: 'Vom Wasser aus die Ufer entdecken',
  ex6Mood: '⛴️ Wasserblick',
  ex6Duration: '15 Min.',

  ex7Title: 'Schifffahrt über den Ammersee',
  ex7Tagline: 'Ein Sommertag auf dem Wasser',
  ex7Mood: '🚢 Entspannt & aussichtsreich',
  ex7Duration: '25 Min.',

  ex8Title: 'Kloster Andechs',
  ex8Tagline: 'Heiliger Berg & Klosterbier',
  ex8Mood: '🍺 Kultur trifft Genuss',
  ex8Duration: '30 Min.',

  ex9Title: 'Baden, SUP oder einfach am Wörthsee entspannen',
  ex9Tagline: 'Der See zum Reinspringen',
  ex9Mood: '🏊 Sommerfeeling',
  ex9Duration: '15 Min.',

  ex10Title: 'Den Wörthsee-Rundweg entlangwandern',
  ex10Tagline: 'Leichte Bewegung, stille Momente',
  ex10Mood: '🚶 Entspannter Rundweg',
  ex10Duration: '12 Min.',

  ex11Title: 'Pilsensee mit Schloss Seefeld verbinden',
  ex11Tagline: 'Wasser und Kultur kombiniert',
  ex11Mood: '🏰 Landschaft & Kultur',
  ex11Duration: '20 Min.',

  ex12Title: 'Weßlinger See',
  ex12Tagline: 'Klein, ruhig und ursprünglich',
  ex12Mood: '🌿 Ruhige Umrundung',
  ex12Duration: '15 Min.',

  ex13Title: 'München – Innenstadt',
  ex13Tagline: 'Die Landeshauptstadt erleben',
  ex13Mood: '🏙️ Shoppen, Schlendern, Staunen',
  ex13Duration: '25 Min. S-Bahn',

  ex14Title: 'Marienplatz',
  ex14Tagline: 'Das Herz von München',
  ex14Mood: '🔔 Glockenspiel & Großstadt',
  ex14Duration: '25 Min. S-Bahn',

  ex15Title: 'Münchens Altstadt erleben',
  ex15Tagline: 'Historische Plätze und lebendige Gassen',
  ex15Mood: '🏛️ Klassiker',
  ex15Duration: '25 Min.',

  ex16Title: 'Über den Viktualienmarkt schlendern',
  ex16Tagline: 'Farben, Düfte und Lebensgefühl',
  ex16Mood: '🥨 Genussmomente',
  ex16Duration: '25 Min.',

  ex18Title: 'Im Englischen Garten spazieren',
  ex18Tagline: 'Mitten in München, mitten im Grünen',
  ex18Mood: '🌳 Stadtbesuch mit Luft',
  ex18Duration: '25 Min.',

  ex20Title: 'Bayerische Alpen',
  ex20Tagline: 'Wenn es größer sein darf',
  ex20Mood: '⛰️ Gipfelglück',
  ex20Duration: '60 Min.',

  ex21Title: 'Pinakotheken München',
  ex21Tagline: 'Weltklasse-Kunst, 25 Min. entfernt',
  ex21Mood: '🎨 Kunst & Kaffee',
  ex21Duration: '25 Min. S-Bahn',

  ex22Title: 'Buchheim Museum besuchen',
  ex22Tagline: 'Kunst, Architektur und Seelage',
  ex22Mood: '🎨 Inspirierende Stunden',
  ex22Duration: '25 Min.',

  ex23Title: 'Museum Starnberger See entdecken',
  ex23Tagline: 'Geschichte und Alltag am See',
  ex23Mood: '🏛️ Anschaulich & charmant',
  ex23Duration: '15 Min.',

  ex24Title: 'Museen, Ausstellungen oder Kultur in München genießen',
  ex24Tagline: 'Eine Stadt voller Kulturgenuss',
  ex24Mood: '🎭 Kulturgenuss',
  ex24Duration: '25 Min.',

  ex25Title: 'Einen Film im Breitwand Gauting sehen',
  ex25Tagline: 'Charmantes Programmkino direkt im Ort',
  ex25Mood: '🎬 Entspannter Abend',
  ex25Duration: 'Direkt',

  ex26Title: 'Würmtal Wanderweg: zum Grubmühlerfeld',
  ex26Tagline: 'Direkt ab Hotel ins Grüne',
  ex26Mood: '🌲 Vor der Tür',
  ex26Duration: 'Direkt',

  ex28Title: 'Eibsee',
  ex28Tagline: 'Bergsee am Fuß der Zugspitze',
  ex28Mood: '💎 Atemberaubend schön',
  ex28Duration: '60 Min.',

  ex29Title: 'Ostersee',
  ex29Tagline: 'Stille Seenkette im Voralpenland',
  ex29Mood: '🌅 Ruhe & Natur',
  ex29Duration: '40 Min.',

  ex34Title: 'Rundweg um den Ostersee',
  ex34Tagline: 'Wandern entlang der Seenkette',
  ex34Mood: '🚶 Stille Runde',
  ex34Duration: '40 Min.',

  ex30Title: 'Staffelsee',
  ex30Tagline: 'Voralpenidyll mit kleinen Inseln',
  ex30Mood: '🐄 Voralpenidyll',
  ex30Duration: '50 Min.',

  ex31Title: 'Midgardhaus Tutzing',
  ex31Tagline: 'Seeblick mit Geschichte',
  ex31Mood: '🏡 Seeblick & Geschichte',
  ex31Duration: '25 Min.',

  ex32Title: 'Würmtal Wanderweg: nach Leutstetten',
  ex32Tagline: 'Ländliche Idylle vor der Tür',
  ex32Mood: '🌾 Ländliche Idylle',
  ex32Duration: 'Direkt',

  ex36Title: 'Schliersee',
  ex36Tagline: 'Ursprünglich, ruhig, bergumrahmt',
  ex36Mood: '🌿 Ursprüngliches Bayern',
  ex36Duration: '55 Min.',

  ex37Title: 'Deutsches Museum',
  ex37Tagline: 'Das größte Technikmuseum der Welt',
  ex37Mood: '🔬 Staunen & Entdecken',
  ex37Duration: '25 Min. S-Bahn',

  ex38Title: 'Zugspitze',
  ex38Tagline: 'Deutschlands höchster Gipfel',
  ex38Mood: '⛰️ Gipfelglück',
  ex38Duration: '80 Min.',

  ex46Title: 'Kloster Ettal',
  ex46Tagline: 'Barocke Pracht im Ammertal',
  ex46Mood: '🏛️ Stille & Besinnung',
  ex46Duration: '65 Min.',

  ex48Title: 'Schloss Linderhof',
  ex48Tagline: 'Ludwigs kleinster, aber liebster Palast',
  ex48Mood: '👑 Königliche Träume',
  ex48Duration: '70 Min.',

  ex54Title: 'Kraftort Petersberg',
  ex54Tagline: 'Basilika auf einem der heiligen Berge Bayerns',
  ex54Mood: '🙏 Stille & Spiritualität',
  ex54Duration: '60 Min.',

  ex56Title: 'BOSCO Gauting',
  ex56Tagline: 'Kultur direkt vor der Hoteltür',
  ex56Mood: '🎭 Kultur vor Ort',
  ex56Duration: 'Direkt',

  // Tipps, Beschreibungen, Highlights
  ex1Tip: 'Tipp: Bootsverleih direkt am Ufer in Starnberg – kein Führerschein nötig!',
  ex1Desc: 'Kristallklares Wasser, sanfte Hügel, Alpenpanorama im Hintergrund. Der Starnberger See ist in 15 Minuten erreichbar und fühlt sich an wie Urlaub im Urlaub.',
  ex1H1: 'Bootsfahrt', ex1H2: 'Baden', ex1H3: 'Uferpromenade', ex1H4: 'Sonnenuntergang',

  ex2Tip: 'Tipp: Fähre von Herrsching nach Andechs – Bier und Aussicht inklusive.',
  ex2Desc: 'Etwas weniger bekannt als der Starnberger See, dafür umso ursprünglicher. Weite Ufer, Segelboote, frischer Fisch – und das Kloster Andechs thront gleich oben drüber.',
  ex2H1: 'Segeln', ex2H2: 'Fähre', ex2H3: 'Fischrestaurants', ex2H4: 'Naturschutzgebiet',

  ex3Tip: 'Tipp: Die Überfahrt per Zille ist ein Erlebnis für sich – nur bei gutem Wetter möglich.',
  ex3Desc: 'Eine stille Insel voller Geschichte, Rosen und königlicher Atmosphäre – erreichbar per Zille und ideal für einen besonderen Ausflug.',
  ex3H1: 'Rosengarten', ex3H2: 'Zille-Überfahrt', ex3H3: 'Königliche Villa', ex3H4: 'Ruhe',

  ex4Tip: 'Tipp: Das Kreuz im Wasser markiert die Stelle, wo König Ludwig II. starb – ein bewegender Ort.',
  ex4Desc: 'Ein stimmungsvoller Spaziergang mit Seeblick und Geschichte: zur Kapelle im Park von Berg und zum Kreuz im Wasser.',
  ex4H1: 'Votivkapelle', ex4H2: 'Kreuz im Wasser', ex4H3: 'Parkanlage', ex4H4: 'Seeblick',

  ex5Tip: 'Tipp: Der Park führt direkt zum Seeufer – perfekt für eine Kombination aus Kultur und Natur.',
  ex5Desc: 'Alte Bäume, weite Wege und elegante Ruhe machen den Lenné-Park zu einem wunderbaren Ort für einen Spaziergang am See.',
  ex5H1: 'Historischer Park', ex5H2: 'Alte Bäume', ex5H3: 'Seeblick', ex5H4: 'Ruhe',

  ex6Tip: 'Tipp: Bei klarem Wetter sieht man die Alpen vom Schiff aus besonders eindrucksvoll.',
  ex6Desc: 'Vom Wasser aus zeigt sich der See besonders schön: mit Villen, Ufern, Weite und bei guter Sicht sogar mit Alpenpanorama.',
  ex6H1: 'Schifffahrt', ex6H2: 'Villen', ex6H3: 'Alpenpanorama', ex6H4: 'Weite',

  ex7Tip: 'Tipp: Die Rundfahrt ab Herrsching ist besonders schön und führt an allen wichtigen Orten vorbei.',
  ex7Desc: 'Weite, Wasser und ein Gefühl von Sommer: Eine Schifffahrt auf dem Ammersee ist entspannt, aussichtsreich und wunderbar leicht.',
  ex7H1: 'Schifffahrt', ex7H2: 'Weite', ex7H3: 'Sommerfeeling', ex7H4: 'Aussicht',

  ex8Tip: 'Tipp: Stiftsschänke direkt am Kloster – Bier vom Fass, Blick über den Ammersee.',
  ex8Desc: 'Erst ans Wasser, dann hinauf zum Kloster: Andechs verbindet Panorama, Geschichte und bayerische Einkehr auf besonders schöne Weise.',
  ex8H1: 'Klosterkirche', ex8H2: 'Klosterbier', ex8H3: 'Aussicht', ex8H4: 'Wallfahrt',

  ex9Tip: 'Tipp: SUP-Verleih direkt am Seeufer – auch für Anfänger perfekt geeignet.',
  ex9Desc: 'Klar, sommerlich und entspannt: Der Wörthsee ist ideal für Baden, SUP oder einfach ein paar ruhige Stunden am Wasser.',
  ex9H1: 'Baden', ex9H2: 'SUP', ex9H3: 'Entspannung', ex9H4: 'Sommer',

  ex10Tip: 'Tipp: Der Rundweg ist etwa 8 km lang und führt durch schöne Uferlandschaften.',
  ex10Desc: 'Ein schöner Weg für leichte Bewegung und stille Seemomente – perfekt für alle, die den Tag draußen entspannt angehen wollen.',
  ex10H1: 'Rundweg', ex10H2: 'Seemomente', ex10H3: 'Natur', ex10H4: 'Leicht',

  ex11Tip: 'Tipp: In Seefeld gibt es kleine Läden und Cafés – perfekt für eine entspannte Pause.',
  ex11Desc: 'Erst ans Wasser, dann nach Schloss Seefeld: ein Ausflug mit Landschaft, kleinen Läden, Kultur und entspannter Atmosphäre.',
  ex11H1: 'Pilsensee', ex11H2: 'Schloss Seefeld', ex11H3: 'Kultur', ex11H4: 'Entspannung',

  ex12Tip: 'Tipp: Der See ist klein genug für eine schnelle Runde – ideal für zwischendurch.',
  ex12Desc: 'Klein, ruhig und wunderbar unkompliziert: Der Weßlinger See eignet sich perfekt für eine Umrundung am Wasser zwischendurch.',
  ex12H1: 'Kleiner See', ex12H2: 'Umrundung', ex12H3: 'Ruhe', ex12H4: 'Natur',

  ex13Tip: 'Tipp: S6 ab Gauting – direkt in die Innenstadt, kein Umsteigen.',
  ex13Desc: 'Glockenspiel, Weißwurst, Weltklasse-Museen und die besten Biergärten Europas. München ist in 25 Minuten da – und fühlt sich trotzdem wie eine eigene Reise an.',
  ex13H1: 'Marienplatz', ex13H2: 'Viktualienmarkt', ex13H3: 'Englischer Garten', ex13H4: 'Shopping',

  ex14Tip: 'Tipp: Das Glockenspiel im Rathausturm spielt täglich um 11 und 12 Uhr – im Sommer zusätzlich um 17 Uhr.',
  ex14Desc: 'Mitten im Herzen der Stadt: Der Marienplatz mit Neuem Rathaus, dem berühmten Glockenspiel und der Mariensäule ist Münchens lebendiger Mittelpunkt. Frauenkirche, Viktualienmarkt und die Fußgängerzone liegen nur wenige Schritte entfernt – mit der S-Bahn ab Gauting in rund 25 Minuten erreichbar.',
  ex14H1: 'Neues Rathaus', ex14H2: 'Glockenspiel', ex14H3: 'Frauenkirche', ex14H4: 'Fußgängerzone',

  ex15Tip: 'Tipp: Frühmorgens ist die Altstadt am schönsten – ohne Menschenmassen.',
  ex15Desc: 'Historische Plätze, schöne Fassaden und lebendige Gassen machen die Altstadt zu einem Klassiker für einen gelungenen Tag in München.',
  ex15H1: 'Historische Plätze', ex15H2: 'Fassaden', ex15H3: 'Gassen', ex15H4: 'Atmosphäre',

  ex16Tip: 'Tipp: Probieren Sie die frischen Obatzda-Stände – ein bayerischer Klassiker!',
  ex16Desc: 'Farben, Düfte und Münchner Lebensgefühl: Der Viktualienmarkt ist ideal für einen entspannten Stadtbummel mit Genussmomenten.',
  ex16H1: 'Markt', ex16H2: 'Genuss', ex16H3: 'Atmosphäre', ex16H4: 'Münchner Lebensgefühl',

  ex18Tip: 'Tipp: Der Chinesische Turm ist ein schöner Zwischenstopp mit Biergarten.',
  ex18Desc: 'Viel Grün, viel Weite und mitten in München doch ganz entspannt – perfekt für einen Stadtbesuch mit Luft und Leichtigkeit.',
  ex18H1: 'Grün', ex18H2: 'Weite', ex18H3: 'Entspannung', ex18H4: 'Mitten in München',

  ex20Tip: 'Tipp: Zugspitze mit der Zahnradbahn – Deutschlands höchster Punkt.',
  ex20Desc: 'Eine Stunde Fahrt, eine andere Welt. Die Alpen bieten im Sommer Wanderparadiese, im Winter Skigebiete – und das ganze Jahr über Panoramen, die sprachlos machen.',
  ex20H1: 'Zugspitze', ex20H2: 'Garmisch', ex20H3: 'Wandern', ex20H4: 'Skifahren',

  ex21Tip: 'Tipp: Sonntags kostet der Eintritt nur 1 € – kein Witz.',
  ex21Desc: 'Drei Pinakotheken, ein Kunstareal. Von Rubens bis Warhol – München hat eine der dichtesten Museumslandschaften Europas. Und das alles in 25 Minuten erreichbar.',
  ex21H1: 'Alte Pinakothek', ex21H2: 'Moderne Kunst', ex21H3: 'Museumsshop', ex21H4: 'Café',

  ex22Tip: 'Tipp: Das Museum liegt direkt am Starnberger See – perfekt für eine Kombination mit Spaziergang.',
  ex22Desc: 'Kunst, Architektur und Seelage treffen hier aufeinander – ein besonderer Kulturort für inspirierende Stunden drinnen.',
  ex22H1: 'Kunst', ex22H2: 'Architektur', ex22H3: 'Seelage', ex22H4: 'Kultur',

  ex23Tip: 'Tipp: Das Museum zeigt auch die Geschichte von König Ludwig II. – sehr sehenswert.',
  ex23Desc: 'Wer die Region besser kennenlernen will, findet hier Geschichte, Alltag und Seeleben auf anschauliche und charmante Weise.',
  ex23H1: 'Geschichte', ex23H2: 'Alltag', ex23H3: 'Seeleben', ex23H4: 'Regional',

  ex24Tip: 'Tipp: Das Deutsche Museum ist das größte Technikmuseum der Welt – ein ganzer Tag reicht kaum.',
  ex24Desc: 'Wenn es etwas mehr Kultur sein darf, bietet München große Museen, Ausstellungen und viele schöne Abende in der Stadt.',
  ex24H1: 'Museen', ex24H2: 'Ausstellungen', ex24H3: 'Kultur', ex24H4: 'Abendprogramm',

  ex25Tip: 'Tipp: Das Breitwand ist ein charmantes Programmkino mit guter Filmauswahl.',
  ex25Desc: 'Ein Kinoabend mit angenehmer Atmosphäre und guter Auswahl – ruhig, nah und genau richtig für einen entspannten Abend.',
  ex25H1: 'Kino', ex25H2: 'Atmosphäre', ex25H3: 'Nah', ex25H4: 'Abendprogramm',

  ex26Tip: 'Tipp: Das Mühltal ist besonders im Herbst wunderschön – mit bunten Blättern und stillen Wegen.',
  ex26Desc: 'Wasser, Bäume und viel Ruhe: Der Würmtal-Wanderweg zum Grubmühlerfeld führt direkt vom Hotel in eine der schönsten Naturlandschaften der Umgebung.',
  ex26H1: 'Würmtal', ex26H2: 'Grubmühlerfeld', ex26H3: 'Ruhe', ex26H4: 'Natur',

  ex28Tip: 'Tipp: Früh losfahren – der Eibsee ist einer der schönsten Seen Deutschlands und entsprechend besucht.',
  ex28Desc: 'Türkisblaues Wasser, kleine Inselchen und direkt über ihm das Zugspitzmassiv: Der Eibsee gehört zu den schönsten Seen Deutschlands – und ist in gut einer Stunde erreichbar.',
  ex28H1: 'Türkisblaues Wasser', ex28H2: 'Zugspitzblick', ex28H3: 'Rundweg', ex28H4: 'Baden',

  ex29Tip: 'Tipp: Der Rundwanderweg um den Ostersee ist besonders schön – naturbelassen und kaum überlaufen.',
  ex29Desc: 'Stilles Wasser, weite Natur und kaum Trubel: Der Ostersee im Voralpenland ist ein Geheimtipp für alle, die Ruhe und unberührte Landschaft suchen.',
  ex29H1: 'Rundwanderweg', ex29H2: 'Naturschutzgebiet', ex29H3: 'Ruhe', ex29H4: 'Abendstimmung',

  ex34Tip: 'Tipp: Der Rundweg ist gut ausgeschildert und führt durch ein wunderschönes Naturschutzgebiet.',
  ex34Desc: 'Ein naturbelassener Rundweg durch Moor, Wald und direkt am Seeufer – der Ostersee-Rundweg ist ideal für alle, die wandern und dabei echte Stille erleben wollen.',
  ex34H1: 'Rundwanderweg', ex34H2: 'Moorlandschaft', ex34H3: 'Wald', ex34H4: 'Ruhe',

  ex30Tip: 'Tipp: Kombinieren Sie den See mit einem Besuch im malerischen Murnau am Staffelsee.',
  ex30Desc: 'Weite Seelagen, Alpenblick und die Nähe zum charmanten Städtchen Murnau machen den Staffelsee zu einem wunderbaren Ausflugsziel in der Voralpenlandschaft.',
  ex30H1: 'Weite', ex30H2: 'Voralpenlandschaft', ex30H3: 'Murnau', ex30H4: 'Naturschutz',

  ex31Tip: 'Tipp: Der Uferweg entlang des Starnberger Sees in Tutzing lohnt sich für einen schönen Spaziergang.',
  ex31Desc: 'Das Midgardhaus in Tutzing ist ein beeindruckendes Jugendstilgebäude direkt am Starnberger See – ein schönes Ziel für einen Spaziergang mit Geschichte und Seeblick.',
  ex31H1: 'Jugendstil', ex31H2: 'Seeblick', ex31H3: 'Tutzing', ex31H4: 'Uferweg',

  ex32Tip: 'Tipp: Der Weg nach Leutstetten führt idyllisch entlang der Würm – ideal für eine entspannte Morgen- oder Abendrunde.',
  ex32Desc: 'Entlang der Würm durch stille Wiesen und Wälder bis ins Dorf Leutstetten – ein wunderbarer Spaziergang direkt vom Hotel aus.',
  ex32H1: 'Würmtal', ex32H2: 'Leutstetten', ex32H3: 'Ruhe', ex32H4: 'Natur',

  ex36Tip: 'Tipp: Vom Schliersee aus lässt sich der Schliersberger Alm über einen kurzen Wanderweg erreichen – lohnt sich! Sehenswert sind außerdem das Markus Wasmeier Freilichtmuseum und die Slyrs Whisky-Brennerei – deren Whisky schenken wir auch bei uns im Haus aus.',
  ex36Desc: 'Der Schliersee liegt ruhig und ursprünglich inmitten der Voralpen – weniger bekannt als der Tegernsee, dafür umso authentischer und naturbelassener.',
  ex36H1: 'Ruhe', ex36H2: 'Bergblick', ex36H3: 'Baden', ex36H4: 'Wandern',

  ex37Tip: 'Tipp: Für einen vollen Besuch mindestens einen halben Tag einplanen – das Museum ist riesig.',
  ex37Desc: 'Das Deutsche Museum auf der Isar-Insel ist das größte Technik- und Naturwissenschaftsmuseum der Welt – mit über 73.000 Exponaten auf elf Etagen.',
  ex37H1: 'Technik', ex37H2: 'Wissenschaft', ex37H3: 'Interaktiv', ex37H4: 'Für alle',

  ex38Tip: 'Tipp: Mit der Zahnradbahn ab Garmisch – oben wartet ein atemberaubendes Panorama über drei Länder.',
  ex38Desc: 'Mit der Zahnradbahn oder Gondel auf Deutschlands höchsten Gipfel: Die Zugspitze auf 2.962 m bietet Panoramablick über Bayern, Österreich und die Schweiz.',
  ex38H1: 'Zahnradbahn', ex38H2: 'Gipfelpanorama', ex38H3: 'Gletscher', ex38H4: 'Höhenrekord',

  ex46Tip: 'Tipp: Der klostereigene Käse und der Ettaler Klosterlikör sind bekannte Spezialitäten – direkt im Klosterladen erhältlich.',
  ex46Desc: 'Das Benediktinerkloster Ettal liegt eingebettet in die Ammergauer Alpen – mit seiner beeindruckenden Barockkirche, einem eigenen Brauhaus und klösterlicher Stille.',
  ex46H1: 'Barockkirche', ex46H2: 'Klosterladen', ex46H3: 'Bergpanorama', ex46H4: 'Geschichte',

  ex48Tip: 'Tipp: Die Parkanlage mit Venusgrotte und Maurischem Kiosk ist ebenso sehenswert wie das Schloss selbst.',
  ex48Desc: 'Schloss Linderhof war das einzige Schloss, das König Ludwig II. vollenden konnte – umgeben von einer traumhaften Parkanlage mit Venusgrotte, Wasserspielen und exotischen Pavillons.',
  ex48H1: 'Schloss', ex48H2: 'Venusgrotte', ex48H3: 'Parkanlage', ex48H4: 'König Ludwig II.',

  ex54Tip: 'Tipp: Der Aufstieg zur Basilika ist kurz und führt durch eine wunderbare Voralpenlandschaft – ein echter Kraftort.',
  ex54Desc: 'Der Petersberg gehört zu den ältesten Wallfahrtsorten Bayerns – ein stiller Kraftort mit romanischer Basilika und weitem Blick über die Voralpenlandschaft.',
  ex54H1: 'Basilika', ex54H2: 'Kraftort', ex54H3: 'Panoramablick', ex54H4: 'Stille',

  ex56Tip: 'Tipp: Vor der Anreise einen Blick ins BOSCO-Programm werfen – Konzerte, Theater und Lesungen sind oft schnell ausverkauft.',
  ex56Desc: 'Das BOSCO ist Gautings Kulturzentrum – mit einem abwechslungsreichen Programm aus Konzerten, Theateraufführungen, Lesungen und Filmen. Von uns aus in wenigen Minuten zu Fuß erreichbar.',
  ex56H1: 'Konzerte', ex56H2: 'Theater', ex56H3: 'Lesungen', ex56H4: 'Lokal',
};
